import React, { useState } from 'react'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { usePersonalStore } from '../../../stores/personalInfo'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import Canvas from '../../canvas'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'
import moment from 'moment'

const HandBookOnline = ({ navigation, route }) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
    } = params

    const [hasDrawn, setHasDrawn] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postgrenadehandbook } = useFormsStore()


    const data = {
        entityId: personalstore.personalData?.entityId,
        essUserKey: intializeStore.initializeData.userkey,
        essObKey: essUserOnBoardingKey,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        completeOnline: true,
        sign: signatureDataURL

    }
    const handlesubmit = async () => {
        const response: any = await postgrenadehandbook(data)
        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'Grocery Basket Employee Handbook'}
                    />
                </View>
            </View>
            <ScrollView>
                <Card
                    style={{
                        fontFamily: "Arial, sans-serif",
                        lineHeight: "1.6",
                        fontSize: '11px'
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <h1 style={{ textAlign: "center" }}>Grocery Basket <br /> Employee Handbook <br /> Receipt</h1>

                    </div>
                    <p>
                        I acknowledge receipt of the Grocery Basket Employee Handbook. I understand
                        the rules and polices contained in this handbook. I understand if I have
                        any questions about the rules and polices it is my responsibly to ask and get
                        a clear understanding.
                    </p>
                    <p>
                        All employees are expected to conform to the rules and polices outlined in
                        this handbook for their position.
                    </p>
                    <p>
                        The content of this handbook does not constitute the terms of a contract or
                        employment and should not be construed as a guarantee of continued
                        employment. Employment with Grocery Basket is on an AT-WILL basis. This
                        means that employment may be terminated at any time by either you or the
                        Company for any reason with or without cause and with or without notice.
                    </p>
                    <div >
                        <p><strong>Name:</strong> <span style={{ textDecoration: "underline" }}>{personalstore?.personalData?.firstName} {personalstore?.personalData?.middleInitial} {personalstore?.personalData?.lastName} </span></p>
                        <p><strong>Date:</strong> <span style={{ textDecoration: "underline" }}>{moment().format("MM/DD/YYYY")}</span></p>

                    </div>

                    <div>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                marginTop: '30px'
                            }}
                        >
                            <tbody>

                                <tr style={{ width: "100%" }}>
                                    <td style={{ width: "70%", fontSize: "11px", display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: '5px' }}>
                                            <strong>Signature : </strong>
                                        </p>
                                        <p>
                                            <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} />
                                        </p>
                                    </td>


                                </tr>
                            </tbody>
                        </table>


                    </div>
                </Card>
                {loading ? (
                    <ActivityIndicator />
                ) : (
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() =>
                                navigation.navigate('OnboardingForms')
                            }
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>
                )}

            </ScrollView >
        </>
    )
}

export default HandBookOnline
